<template>
    <div>
        <v-divider></v-divider>
        <v-subheader
            @click="open = !open"
        >
            <v-list-item-icon>
                <v-icon>
                    mdi-passport
                </v-icon>
            </v-list-item-icon>
            Passport
            <v-spacer></v-spacer>
            <v-btn
                icon
            >
                <v-icon v-if="!open">
                    mdi-chevron-up
                </v-icon>
                <v-icon v-else>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </v-subheader>
        <v-expand-transition>
            <div
                v-if="open"
            >
                <v-list-item
                        v-if="passport.number"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ passport.number }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Passport Number
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                        v-if="passport.validUntil"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ passport.validUntil }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Passport valid till
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                        v-if="passport.country"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ passport.country }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Passport country
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                        v-if="passport.authority"
                >
                    <v-list-item-icon></v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ passport.authority }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Issuing authority
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
    export default {
        props: {
            passport: {
                type: Object,
                required: true
            },
        },
        data: () => ({
            open: false,
        }),
    }
</script>

<style lang="scss" scoped>
    .v-subheader {
        cursor: pointer;
        height: 56px;
    }
</style>
